import React, { FC } from 'react';
import { DateProps } from './types';
import dayjs from 'dayjs';

const DateComponent: FC<DateProps> = ({
  dateTime,
  format = 'YYYY/MM/DD',
  additionalText = null,
}) => {
  // !Invalid datetime strings will cause an exception.
  try {
    const date = dayjs(dateTime);

    const isDateValid = date.isValid() && dateTime !== '0001-01-01T00:00:00';
    return (
      <time dateTime={dateTime}>
        {isDateValid ? date.format(format) : ''}
        {additionalText && ` ${additionalText}`}
      </time>
    );
  } catch (error) {
    console.error('Error parsing date:', error);
    return null;
  }
};

export default DateComponent;
